// extracted by mini-css-extract-plugin
export default {"team":"team_team__TwmvJ"};